module.exports = __webpack_public_path__ + "img/donner_pass.e71b8c9f.png";